import { render, staticRenderFns } from "./ContentPagesDetail.vue?vue&type=template&id=3d4698e3"
import script from "./ContentPagesDetail.vue?vue&type=script&lang=js"
export * from "./ContentPagesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports